<template>
  <div class="carousel-container">
    <div class="carousel">
      <div class="carousel-inner" ref="carouselInner">
        <div v-for="(image, index) in images" :key="index" class="carousel-item">
          <img :src="image" alt="Carousel image" class="carousel-image" />
        </div>
      </div>
      <button class="carousel-control prev" @click="prevSlide">&larr;</button>
      <button class="carousel-control next" @click="nextSlide">&rarr;</button>
      <div class="carousel-dots">
        <span
          v-for="(image, index) in images"
          :key="index"
          class="dot"
          :class="{ active: index === currentIndex }"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";

import img1 from "@/assets/crousal/crousal1.jpeg";
import img2 from "@/assets/crousal/crousal2.jpeg";
import img3 from "@/assets/crousal/crousal3.jpeg";
import img4 from "@/assets/crousal/crousal4.jpeg";
import img6 from "@/assets/crousal/crousal6.jpeg";
import img7 from "@/assets/crousal/crousal7.jpeg";
import img8 from "@/assets/crousal/crousal8.jpeg";

export default {
  name: "ImageCarousel",
  data() {
    return {
      images: [img1, img2, img3, img4, img6, img7, img8],
      currentIndex: 0,
      intervalId: null
    };
  },
  methods: {
    animateSlide() {
      const offset = -(this.currentIndex * 100);
      gsap.to(this.$refs.carouselInner, { xPercent: offset, duration: 0.7, ease: "power2.out" });
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.animateSlide();
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.animateSlide();
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.animateSlide();
    }
  },
  mounted() {
    this.animateSlide();
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 5000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  }
};
</script>


<style scoped>
.carousel-container {
width: 100%;
margin: 0;
padding: 0;
}

.carousel {
position: relative;
overflow: hidden;
width: 100%;
}

.carousel-inner {
 display: flex;
 transition: none; /* Disable default so GSAP can animate */
 width: 100%;
}

.carousel-item {
 min-width: 100%;
 box-sizing: border-box;
}

.carousel-image {
 width: 100%;
 height: 450px;
 object-fit: cover;
}

.carousel-control {
 position: absolute;
 top: 50%;
 transform: translateY(-50%);
 background: rgba(0, 0, 0, 0.5);
 color: white;
 border: none;
 cursor: pointer;
 font-size: 24px;
 padding: 10px;
 z-index: 10;
}
.prev {
 left: 10px;
}
.next {
 right: 10px;
}
.carousel-dots {
 text-align: center;
 padding: 10px 0;
}
.dot {
 height: 10px;
 width: 10px;
 background-color: #bbb;
 border-radius: 50%;
 display: inline-block;
 margin: 0 5px;
 cursor: pointer;
}
.dot.active {
 background-color: #717171;
}

/* ---- Responsive Styles ---- */
@media (max-width: 700px) {
 .carousel-image {
  height: 240px;
 }
 .carousel-control {
  font-size: 18px;
  padding: 6px;
 }
}
@media (max-width: 500px) {
 .carousel-image {
  height: 160px;
 }
 .dot {
  height: 8px;
  width: 8px;
 }
}
</style>
